import { listMenus } from "@/api/system/resource";
import router, { dynamicRoutes, constantRoutes } from '@/router'

const permission = {
  state: {
    roles: [],//角色
    menus: [],//菜单
    buttons: [],//按钮
    routes: []//路由
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.routes = constantRoutes.concat(routes)
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
  },
  actions: {
    // 生成菜单
    GenerateMenus({ commit }) {
      return new Promise(resolve => {
        let queryParams = new Object();
        queryParams.isDeleted = 0;

        //向后端请求角色分配菜单
        listMenus(queryParams).then(res => {
          const menus = res.data;
          formatId(menus);
          let dynamic = genRouters(menus);
          commit('SET_MENUS', menus);
          commit('SET_ROUTES', dynamicRoutes);

          resolve(dynamic);
        });
      })
    },
    //登出时清空菜单
    ClearMenu({ commit }) {
      return new Promise(resolve => {
        commit('SET_MENUS', []);
        resolve();
      })
    }
  }
}

// 菜单插件要求defaultActive必须传入String类型，数据库id是Number类型，这里递归转换一下
export function formatId(menus) {
  for(let m of menus){
    m.id = String(m.id);
    if(m.children) {
      formatId(m.children);
    }
  }
}

// 生成动态路由
export function genRouters(menus) {
  if(menus.length < 1) {
    //没有菜单
    return null;
  }
  for(let menu of menus) {
    if(menu.type == 'C') {
      let child = new Object();
      child.path = menu.path;
      child.component = (resolve) => require(['@/views' + menu.path + '/index'], resolve);
      dynamicRoutes[0].children.push(child);
    } else if (menu.type == 'M') {
      if(menu.children && menu.children.length > 0) {
        genRouters(menu.children);
      }
    }
  }

  return dynamicRoutes;
}

export default permission
